module.exports = __webpack_public_path__ + "img/2@3x.edc73b6c.png";